export function formatAmount(
  amount: number,
  decimalSeperator: string,
  thousandSeperator: string,
  howManyDecimals: number,
): string {
  try {
    const amountString = amount.toFixed(howManyDecimals >= 10 ? 10 : howManyDecimals);
    const [integer, decimal] = amountString.split('.');
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeperator);
    return decimal ? `${formattedInteger}${decimalSeperator}${decimal}` : formattedInteger;
  } catch {
    return amount.toFixed(2);
  }
}
